import sayswitch from '@/assets/logo.svg';



export default function BestafLogo() {
    return <div className="flex items-center space-x-2 mb-3 justify-center">  <img src={sayswitch} className="object-contain !h-[40px]" alt="logo" /> <h2 className="text-primary font-bold">Bestaf</h2> </div>

}